import classNames from 'classnames';
import { FunctionComponent, PropsWithChildren } from 'react';
import { SidebarItemProps } from './SidebarItemProps';

export const SidebarItem: FunctionComponent<PropsWithChildren<SidebarItemProps>> = ({
  children,
  isSelected = false,
  icon,
  selectedIcon,
  onClick
}) => {
  const selectedAttributes: string = 'text-white bg-tint';
  const unselectedAttributes: string = 'text-text hover:bg-black hover:bg-opacity-5';

  return (
    <button
      className={classNames(
        'w-full px-4 py-1.5 font-medium text-left',
        isSelected ? selectedAttributes : unselectedAttributes,
        'rounded-lg cursor-pointer'
      )}
      onClick={onClick}
    >
      <div className="items-center space-x-2 h-stack">
        <div className="w-5 h-5">
          {!isSelected && icon ? <img src={icon} /> : undefined}
          {isSelected && selectedIcon ? <img src={selectedIcon} /> : undefined}
        </div>
        <div>{children}</div>
      </div>
    </button>
  );
};
